(function () {
	'use strict';

	angular.module('mx.components').component('mxFormValidation', {
		require: {
			mxFormCtrl: '?^mxForm',
		},
		bindings: {
			valid: '=?',
		},
		template: '',
		controller: MxFormValidationCtrl,
		controllerAs: 'vm',
	});

	function MxFormValidationCtrl() {
		var vm = this;

		vm.$postLink = function () {
			var form = vm.mxFormCtrl || {};

			Object.defineProperty(vm, 'valid', {
				get: function () {
					return form.valid;
				},
			});
		};
	}
})();
